module.exports = __webpack_public_path__ + "static/solution14-bfff08c7a155b59978d4851c36b84a27.png";